import { db } from '../firebaseConfig';
import { collection, doc, getDocs, getDoc, addDoc, updateDoc, deleteDoc, query, where } from 'firebase/firestore';
import { ReglaSancionAutomatica } from '../models/types';

const COLLECTION_NAME = 'reglasSancionesAutomaticas';

// Servicio para gestionar las reglas de sanciones automáticas
export const reglaSancionAutomaticaServiceFirestore = {
  // Obtener todas las reglas
  getAll: async (): Promise<ReglaSancionAutomatica[]> => {
    try {
      const querySnapshot = await getDocs(collection(db, COLLECTION_NAME));
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as ReglaSancionAutomatica));
    } catch (error) {
      console.error('Error al obtener reglas de sanciones automáticas:', error);
      return [];
    }
  },

  // Obtener reglas activas
  getActivas: async (): Promise<ReglaSancionAutomatica[]> => {
    try {
      const q = query(collection(db, COLLECTION_NAME), where('activa', '==', true));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as ReglaSancionAutomatica));
    } catch (error) {
      console.error('Error al obtener reglas activas:', error);
      return [];
    }
  },

  // Obtener una regla por ID
  getById: async (id: string): Promise<ReglaSancionAutomatica | null> => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return {
          id: docSnap.id,
          ...docSnap.data()
        } as ReglaSancionAutomatica;
      } else {
        console.log(`No se encontró la regla con ID ${id}`);
        return null;
      }
    } catch (error) {
      console.error(`Error al obtener la regla ${id}:`, error);
      return null;
    }
  },

  // Crear una nueva regla
  create: async (regla: Omit<ReglaSancionAutomatica, 'id'>): Promise<ReglaSancionAutomatica | null> => {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...regla,
        fechaCreacion: regla.fechaCreacion || new Date().toISOString().split('T')[0]
      });
      
      return {
        id: docRef.id,
        ...regla
      } as ReglaSancionAutomatica;
    } catch (error) {
      console.error('Error al crear la regla:', error);
      return null;
    }
  },

  // Actualizar una regla existente
  update: async (id: string, regla: Partial<ReglaSancionAutomatica>): Promise<boolean> => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        ...regla,
        fechaModificacion: new Date().toISOString().split('T')[0]
      });
      return true;
    } catch (error) {
      console.error(`Error al actualizar la regla ${id}:`, error);
      return false;
    }
  },

  // Eliminar una regla
  delete: async (id: string): Promise<boolean> => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await deleteDoc(docRef);
      return true;
    } catch (error) {
      console.error(`Error al eliminar la regla ${id}:`, error);
      return false;
    }
  },

  // Activar o desactivar una regla
  toggleActivacion: async (id: string, activa: boolean): Promise<boolean> => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        activa,
        fechaModificacion: new Date().toISOString().split('T')[0]
      });
      return true;
    } catch (error) {
      console.error(`Error al cambiar el estado de la regla ${id}:`, error);
      return false;
    }
  }
};
